"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setHidden;
// make a given rgba value transparent
function setHidden(pixel) {
  // @ts-ignore
  pixel[3] = 0;
  // @ts-ignore
  return pixel;
}